<app-chip-filters>
  <app-chip-filter
    data-at-filter="viguide"
    gtm="onSelectUpdateTab"
    gtmAction="ViGuide updates"
    gtmCategory="updates"
    [active]="activeTab === changeLogTypeEnum.ViGuide"
    [count]="viGuideUpdatesAmount"
    (click)="onTabSelect(changeLogTypeEnum.ViGuide)"
  >
    {{ '+UPDATES.TAB.VIGUIDE' | translate }}
  </app-chip-filter>
  <app-chip-filter
    *ngIf="viCareAndroidUpdatesAmount"
    data-at-filter="vicare-android"
    gtm="onSelectUpdateTab"
    gtmAction="ViCare Android updates"
    gtmCategory="updates"
    [active]="activeTab === changeLogTypeEnum.ViCareAndroid"
    [count]="viCareAndroidUpdatesAmount"
    (click)="onTabSelect(changeLogTypeEnum.ViCareAndroid)"
  >
    {{ '+UPDATES.TAB.VICARE_ANDROID' | translate }}
  </app-chip-filter>
  <app-chip-filter
    *ngIf="viCareIOSUpdatesAmount"
    data-at-filter="vicare-ios"
    gtm="onSelectUpdateTab"
    gtmAction="ViCare IOS updates"
    gtmCategory="updates"
    [active]="activeTab === changeLogTypeEnum.ViCareIOS"
    [count]="viCareIOSUpdatesAmount"
    (click)="onTabSelect(changeLogTypeEnum.ViCareIOS)"
  >
    {{ '+UPDATES.TAB.VICARE_IOS' | translate }}
  </app-chip-filter>
</app-chip-filters>
